<template>
  <a-drawer
    :wrapClassName="$store.state.bgLight ? 'lightColor' : ''"
    :title="title"
    :width="1024"
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收集人员">
              <a-tree-select
                style="width: 100%"
                :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                :treeData="userTree"
                :disabled="disableSubmit"
                show-search
                treeNodeFilterProp="title"
                v-decorator="['userId', validatorRules.userId]"
                placeholder="请选择收集人员"
              >
                <template slot="title" slot-scope="{ title }">ABC{{ title }}</template>
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收集时间">
              <!-- <a-date-picker style="width:100%" ref="stime" format="YYYY-MM-DD HH:mm:ss"
								v-decorator="[ 'stime', validatorRules.stime]"
								:show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
								:disabled="disableSubmit" /> -->
              <a-range-picker
                :disabled="disableSubmit"
                style="width: 100%"
                v-decorator="['rangeTime', rangeConfig]"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="12" :sm="24">
						<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收集结束时间">
							<a-date-picker style="width:100%" ref="etime" format="YYYY-MM-DD HH:mm:ss"
								v-decorator="[ 'etime', validatorRules.etime]"
								:show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
								:disabled="disableSubmit" />
						</a-form-item>
					</a-col> -->
          <a-col :md="24" :sm="24">
            <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="存放地点">
              <!-- <a-textarea :rows="2" placeholder="请输入存放地点" v-decorator="['addr',{}]"
								:disabled="disableSubmit" /> -->
              <j-dict-select-tag
                :triggerChange="true"
                :defaultState="true"
                dictCode="storage_place"
                :search="true"
                v-decorator="['addr', validatorRules.addr]"
                placeholder="请选择"
                :disabled="disableSubmit"
              >
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
              <a-textarea :rows="2" placeholder="请输入备注" v-decorator="['remark', {}]" :disabled="disableSubmit" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :gutter="24">
            <a-tabs>
              <a-tab-pane tab="设备仪表">
                <a-row>
                  <a-col :span="24" :gutter="24">
                    <a-table :columns="paramColumns" :dataSource="paramData" :pagination="false" bordered>
                      <template slot="assetName" slot-scope="text, record, index">
                        <template>{{ text }}</template>
                      </template>

                      <template slot="factorName" slot-scope="text, record, index">
                        <template>{{ text }}</template>
                      </template>

                      <template slot="quantity" slot-scope="text, record, index">
                        <a-input-number
                          v-if="record.editable"
                          style="margin: -5px 0"
                          :min="0"
                          :step="0.01"
                          :value="text"
                          @change="(e) => handleChangeTable(e, record.key, 'quantity')"
                        />
                        <template v-else>{{ text }}</template>
                      </template>

                      <template slot="remark" slot-scope="text, record, index">
                        <a-input
                          v-if="record.editable"
                          style="margin: -5px 0"
                          :value="text"
                          @change="(e) => handleChangeTable(e.target.value, record.key, 'remark')"
                        />
                        <template v-else>{{ text }}</template>
                      </template>
                    </a-table>
                  </a-col>
                </a-row>
              </a-tab-pane>
            </a-tabs>
          </a-col>
        </a-row>
        <a-row style="padding-top: 10px">
          <a-col>
            <iws-upload
              ref="iwupload"
              :options="{ btnText: '上传现场照片' }"
              :disableSubmit="disableSubmit"
              accept=".png,.jpg,.svg,.jpeg"
              filesrc="waste_collect"
              :srcid="this.model.id"
            ></iws-upload>
          </a-col>
        </a-row>
        <div class="drawer-msg" v-show="disableSubmit">
          <a-row>
            <a-col :span="12"> 创建信息：{{ model.createBy_userName }} （{{ model.createTime }}） </a-col>
            <a-col :span="12"> 最后修改信息：{{ model.updateBy_userName }} （{{ model.updateTime }}） </a-col>
          </a-row>
        </div>
      </a-form>
    </a-spin>
    <div class="drawer-tool" v-show="!disableSubmit">
      <a-button icon="close" @click="handleCancel">取消</a-button>
      <a-button type="primary" :disabled="!networkStatus" icon="check" @click="handleOk">确定</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { ModalFormMixin } from '@/mixins/ModalFormMixin'
import IwsUpload from '@comp/upload/IwsUpload'
import { getAction, httpAction } from '@/api/manage'
import { queryUserTreeList } from '@/api/api'
import pick from 'lodash.pick'
import moment from 'moment'

const paramColumns = [
  {
    title: '设备仪表',
    dataIndex: 'assetName',
    align: 'center',
    width: '30%',
    scopedSlots: {
      customRender: 'assetId',
    },
  },
  {
    title: '监测项目',
    dataIndex: 'factorName',
    align: 'center',
    width: '20%',
    scopedSlots: {
      customRender: 'factorName',
    },
  },
  {
    title: '废液量（L）',
    dataIndex: 'quantity',
    align: 'center',
    width: '20%',
    scopedSlots: {
      customRender: 'quantity',
    },
  },
  {
    title: '备注',
    dataIndex: 'remark',
    align: 'center',
    width: '30%',
    scopedSlots: {
      customRender: 'remark',
    },
  },
]

const paramData = []
const addParamDataIndex = 0

export default {
  name: 'WasteCollectModal',
  components: {
    IwsUpload,
  },
  mixins: [ModalFormMixin],
  data() {
    this.cacheParamData = paramData.map((item) => ({
      ...item,
    }))
    return {
      rangeConfig: {
        rules: [
          {
            type: 'array',
            required: true,
            message: '请选择巡检时间!',
          },
        ],
      },
      title: '废液收集表单',
      tableName: 'om_waste_collect',
      paramColumns,
      paramData,
      addParamDataIndex,
      userTree: [],
      form_fields: ['siteId', 'userId', 'dealId', 'remark', 'addr'],
      form_fields_time: ['stime', 'etime'],
      validatorRules: {
        stime: {
          rules: [
            {
              required: true,
              message: '请选择收集开始时间!',
            },
          ],
        },
        etime: {
          rules: [
            {
              required: true,
              message: '请选择收集结束时间!',
            },
          ],
        },
        addr: {
          rules: [
            {
              required: true,
              message: '请选择存放地点!',
            },
          ],
        },
        userId: {
          rules: [
            {
              required: true,
              message: '请输入运维人员!',
            },
          ],
        },
      },
    }
  },
  props: ['pagePath'],
  created() {
    this.queryUserTreeList()
  },
  methods: {
    moment,
    add(siteId) {
      console.log('record', siteId)
      if (undefined == siteId) this.$message.warning('请选择单个站点')
      this.edit({
        siteId,
      })
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      if (!this.model.userId) this.model.userId = this.$store.getters.userInfo.id
      if (undefined == this.model.collectDate) this.model.collectDate = new Date().toLocaleDateString()
      this.visible = true
      this.loadItem(this.model.id)
      this.$nextTick(() => {
        var that = this
        that.form.setFieldsValue(pick(that.model, that.form_fields))
        //时间格式化
        // let timeVal = {}
        // that.form_fields_time.forEach((item, index) => {
        // 	timeVal[item] = that.model[item] ? moment(that.model[item]) : null
        // })
        // that.form.setFieldsValue(timeVal)
        that.form.setFieldsValue({
          rangeTime: [
            that.model.stime ? moment(that.model.stime) : null,
            that.model.etime ? moment(that.model.etime) : null,
          ],
        })
      })
    },
    loadItem(id) {
      let itemData = []
      if (undefined != id) {
        getAction('/waste/collect/item/queryByCollect' + '/' + id).then((res) => {
          if (res.success) {
            itemData = res.result
            this.loadAssetInfo(itemData)
          }
        })
      } else {
        this.loadAssetInfo(itemData)
      }
    },
    
    loadAssetInfo(itemData) {
      let assetInfoData = []
      this.paramData = []
      let that = this
      let params = {status:1}
      getAction('/ea/asset/info/queryBySiteId' + '/' + this.model.siteId,params).then((res) => {
        if (res.success) {
          assetInfoData = res.result
          let paramList = []
          for (let i = 0; i < assetInfoData.length; i++) {
            let param = assetInfoData[i]
            // debugger
            param.key = param.id
            param.assetId = param.id
            param.assetName = param.productName
            param.factorName = param.factorName

            if (itemData.length > 0) {
              const newData = [...itemData]
              const target = newData.filter((item) => param.assetId === item.assetId)[0]
              param.quantity = target.quantity
              param.remark = target.remark
            } else {
              param.quantity = ''
              param.remark = ''
            }
            param.editable = !that.disableSubmit
            paramList.push(param)
          }
          that.paramData = paramList
        }
      })
    },
    // 技术参数表格相关的操作函数
    handleChangeTable(value, key, column) {
      const newData = [...this.paramData]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target[column] = value
        this.paramData = newData
      }
    },
    queryUserTreeList() {
      var that = this
      that.userTree = []
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.userTree.push(temp)
          }
        }
      })
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = Object.assign(that.model, values)

          //时间格式化
          let rangeTimeValue = values['rangeTime']
          formData.stime = rangeTimeValue[0] ? rangeTimeValue[0].format('YYYY-MM-DD HH:mm:ss') : null
          formData.etime = rangeTimeValue[1] ? rangeTimeValue[1].format('YYYY-MM-DD HH:mm:ss') : null
          // that.paramData.forEach(item => {
          // 	item.id = undefined
          // });
          formData.wasteCollectItemList = that.paramData
          formData = this.$refs.iwupload.getUploadListToFromData(formData)
          //console.log(formData)
          let httpurl = '',
            method = ''
          if (!this.model.id) {
            httpurl = this.url.add ? this.url.add : this.pagePath
            method = 'post'
          } else {
            httpurl = this.url.edit ? this.url.edit : this.pagePath
            method = 'put'
          }
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                this.$refs.iwupload.resetUploadFiles()
                this.$notification.success({
                  message: res.message,
                })
                that.$emit('ok')
                that.close()
              } else {
                this.$notification.warning({
                  message: res.message,
                })
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>
